// import React from "react";

// const DynamicDataTable = ({ data = [] }) => {
//   if (!Array.isArray(data) || data.length === 0) {
//     return <p className="text-gray-500">No data available</p>;
//   }

//   // Dynamically extract column keys from the first object
//   const columns = Object.keys(data[0]);

//   return (
//     <div className="overflow-x-auto border rounded-lg shadow-sm">
//       <table className="min-w-full table-auto text-sm">
//         <thead className="bg-gray-100">
//           <tr>
//             {columns.map((col) => (
//               <th key={col} className="px-4 py-2 text-left font-semibold text-gray-700 capitalize">
//                 {col}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((row, idx) => (
//             <tr key={idx} className="border-t">
//               {columns.map((col) => (
//                 <td key={col} className="px-4 py-2">
//                   {typeof row[col] === "object"
//                     ? JSON.stringify(row[col])
//                     : row[col]}
//                 </td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default DynamicDataTable;
import React from "react";

const DynamicDataTable = ({ data = [] }) => {
  if (!Array.isArray(data) || data.length === 0) {
    return <p className="text-gray-500">No data available</p>;
  }

  // Step 1: Collect all unique field names
  const allFields = new Set();
  data.forEach((row) => {
    Object.keys(row).forEach((key) => {
      if (key !== "errorArray") {
        allFields.add(key);
      }
    });
  });
  const fieldNames = Array.from(allFields);

  // Step 2: Format data rows
  const rows = data.map((row, rowIndex) => {
    const { errorArray = [], ...fields } = row;
    const errorText = errorArray.length > 0 ? errorArray.join("\n") : "—";

    return {
      rowNumber: rowIndex + 2,
      fields,
      errorText,
    };
  });

  return (
    <div className="overflow-x-auto border rounded-lg shadow-sm mt-4">
      <table className="min-w-full table-auto text-sm border-collapse">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left font-semibold text-gray-700 border">Row</th>
            {fieldNames.map((field) => (
              <th key={field} className="px-4 py-2 text-left font-semibold text-gray-700 border">
                {field}
              </th>
            ))}
            <th className="px-4 py-2 text-left font-semibold text-gray-700 border">Error Messages</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(({ rowNumber, fields, errorText }, idx) => (
            <tr key={idx} className="border-t">
              <td className="px-4 py-2 border">{rowNumber}</td>
              {fieldNames.map((field) => (
                <td key={field} className="px-4 py-2 border text-gray-700">
                  {fields[field] !== undefined ? fields[field] : "—"}
                </td>
              ))}
              <td className="px-4 py-2 border text-red-600 whitespace-pre-line">{errorText}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DynamicDataTable;








